import {ResourceType} from "../../definitions/types";
import {WarrantyModel} from "../domain/warrantyModel";

export class WarrantiesModel {
    private readonly _warranties: WarrantyModel[];

    constructor(public readonly resources: ResourceType[]) {
        this._warranties = resources
            .filter(resource => resource.type === 1 || resource.type === 2)
            .map(resource => new WarrantyModel(resource));
    }

    /**
     * @method warranties
     * @description Returns the warranty array of the model
     * @returns {WarrantyModel[]}
     */
    public get warranties(): WarrantyModel[] {
        return this._warranties;
    }
}